export const translations = {
  es: {
    navbar: {
      openUntil: 'Abiertos hasta las 9 PM',
      callUs: 'LLÁMANOS',
    },
    hero: {
      subtitle: 'En el Bronx Todos Saben',
      tagline1: 'Where Legends',
      tagline2: 'Get Their Fade',
      address: '926A East Tremont Ave, Bronx NY',
      openUntil: 'ABIERTOS HASTA LAS 9 PM',
      cta: 'LLÁMANOS AHORA — (347) 605-8521',
      walkins: 'Walk-ins Bienvenidos • Excelente para Niños',
    },
    painStory: {
      line1: 'Son las 7 de la tarde.',
      line2: 'Acabas de salir del trabajo.',
      line3: 'Llevas días pensando en ese corte que necesitas.',
      line4: 'Pero sabes cómo termina esto —',
      line5: 'Llegas a tu barbería de siempre y el letrero dice:',
      closed: '"CLOSED."',
      again: 'Otra vez.',
      line6:
        'Y tú te quedas ahí parado en la calle, con el mismo corte de hace tres semanas, pensando:',
      quote:
        '"¿Por qué es tan difícil encontrar una buena barbería que entienda mis horarios?"',
      line7:
        'Eso nos lo dicen todos los que vienen a VillaCon por primera vez.',
      bullet1: 'Hombres que trabajaban de día.',
      bullet2: 'Papás que solo tienen tiempo libre por las noches.',
      bullet3: 'Jóvenes que van a la escuela y salen tarde.',
      line8: 'Todos con lo mismo en común:',
      line9:
        'Cansados de que las barberías del barrio no los respeten ni a ellos ni a su tiempo.',
    },
    problemList: {
      heading: 'El problema no eres tú.',
      sub1: 'El problema es que la mayoría de las barberías en el Bronx cierran a las 6, 7 PM como máximo.',
      sub2: 'Como si los hombres del barrio no tuvieran vida real.',
      sub3: 'Como si todos trabajáramos de 9 a 5 y viviéramos a dos cuadras.',
      sub4: 'Y cuando por fin llegas a tiempo...',
      prob1: 'El barbero que te gusta no está',
      prob2: 'La espera es de hora y media',
      prob3: 'El corte queda a medias porque están apurando para cerrar',
      prob4: 'Pagas lo mismo por la mitad del trabajo',
      closing: 'Eso no es una barbería. Eso es falta de respeto.',
    },
    solution: {
      heading1: 'VillaCon BarberShop',
      heading2: 'existe por una razón:',
      subtitle:
        'Para que ningún hombre del Bronx tenga que elegir entre trabajar y verse fresh.',
      card1Title: 'En el corazón de tu barrio',
      card1Sub: 'Abrir en Google Maps →',
      card2Title: 'Nuestro Horario',
      monThu: 'Lun – Jue',
      fri: 'Viernes',
      sat: 'Sábado',
      sun: 'Domingo',
      closing: 'Porque sabemos que tu vida no termina a las 5.',
    },
    experience: {
      heading1: '¿Qué te espera cuando',
      heading2: 'entras a VillaCon?',
      line1:
        'Desde el momento en que cruzas la puerta, la experiencia es diferente.',
      noChaos: 'No hay caos',
      noYelling: 'No hay gritos',
      noMess: 'No hay desorden',
      prof: 'Hay profesionalismo.',
      line2:
        'Hay un barbero que te mira a los ojos, te escucha, y entiende exactamente lo que quieres.',
      line3: 'Y cuando te sientas en esa silla —',
      trust: 'Confías.',
      line4: 'Porque sabes que vas a salir exactamente como pediste.',
    },
    barbers: {
      heading1: 'Nuestro',
      heading2: 'Equipo',
      subtitle: 'Los profesionales detrás de cada fade perfecto',
      barberLabel: 'Barber',
      bookHover: 'Reservar Cita',
    },
    services: {
      heading1: 'Nuestros',
      heading2: 'Servicios',
      s1Title: 'Fade Perfecto',
      s1Desc: 'Bajo, medio o alto — ejecutado con precisión quirúrgica',
      s2Title: 'Lineup & Bordes',
      s2Desc: 'Líneas limpias que definen tu estilo',
      s3Title: 'Arreglo de Barba',
      s3Desc: 'Detalle profesional, bordes perfectos',
      s4Title: 'Cortes para Niños',
      s4Desc: 'Con paciencia, cuidado y mano experta',
      s5Title: 'Diseños Personalizados',
      s5Desc: 'Tu estilo, tu identidad, tu corte',
      s6Title: 'Full Service',
      s6Desc: 'Corte + barba + lineup completo',
    },
    additionalServices: {
      heading1: 'Servicios',
      heading2: 'Adicionales',
      subtitle: 'Complementa tu corte con nuestros servicios premium',
      s1Title: 'Tratamiento Capilar',
      s1Desc: 'Hidratación y cuidado profundo para tu cabello',
      s2Title: 'Toalla Caliente',
      s2Desc: 'Relajación total con toalla caliente después del corte',
      s3Title: 'Cejas',
      s3Desc: 'Perfilado y limpieza de cejas con precisión',
      s4Title: 'Tinte de Cabello',
      s4Desc: 'Color profesional para un look renovado',
      s5Title: 'Black Mask',
      s5Desc: 'Limpieza facial profunda con máscara negra',
      s6Title: 'Afeitado Clásico',
      s6Desc: 'Afeitado tradicional con navaja y espuma caliente',
    },
    banner: {
      heading1: 'Nuestros',
      heading2: 'Estilos',
      subtitle: 'Elige tu estilo — lo ejecutamos con precisión',
      overlay: '29+ Estilos — Pide el Tuyo',
    },
    comparison: {
      heading1: 'Por Qué VillaCon y No Cualquier',
      heading2: 'Otra Barbería de Tremont:',
      col1: 'Lo Que Encuentras en Otras Partes',
      col2: 'Lo Que Encuentras en VillaCon',
      mob1: 'Otras Partes',
      mob2: 'En VillaCon',
      c1Bad: 'Cierran a las 6-7 PM',
      c1Good: 'Abiertos hasta las 9 PM todos los días',
      c2Bad: 'Barbero diferente cada visita',
      c2Good: 'Profesionales que conocen tu estilo',
      c3Bad: 'Esperas de 2 horas sin aviso',
      c3Good: 'Atención organizada y respetuosa',
      c4Bad: 'Cortes apresurados al final del día',
      c4Good: 'Misma calidad a las 8 PM que a las 9 AM',
      c5Bad: 'No aptos para niños',
      c5Good: 'Excelente para toda la familia',
      c6Bad: 'Tienes que buscar estacionamiento lejos',
      c6Good: 'East Tremont Ave — en el corazón del barrio',
      c7Bad: 'No atienden tarde',
      c7Good: 'El único spot en Tremont abierto cuando los demás ya cerraron',
    },
    lateHours: {
      subtitle: 'Lo Más Importante Que Nadie Más Te Da:',
      heading1: 'Abiertos Hasta',
      heading2: 'Las 9 PM',
      line1: 'Porque tu tiempo vale tanto como el de cualquiera.',
      line2: 'No importa si saliste tarde del trabajo.',
      line3: 'No importa si tuviste que recoger a los niños primero.',
      line4: 'No importa si tu día no empezó hasta el mediodía.',
      line5: 'En VillaCon',
      line6: 'siempre hay un lugar para ti.',
    },
    kids: {
      heading1: 'Llevamos a Tu',
      heading2: 'Hijo También',
      q: '¿Tienes niños?',
      line1: 'Sabemos lo que es intentar llevar a un niño a la barbería.',
      line2:
        'La espera. La incomodidad. El nerviosismo del pequeño en la silla.',
      box: 'En VillaCon somos excelentes con los niños. Nuestros barberos tienen paciencia, tienen técnica, y tienen el toque especial para que tu hijo salga con el mejor corte — Y con una sonrisa.',
      quote:
        'Porque cuando papá y el hijo salen juntos de VillaCon con los mejores fades del barrio — Eso no tiene precio.',
    },
    testimonials: {
      heading1: 'Lo Que Dicen',
      heading2: 'Los Que Ya Vienen',
      t1Quote:
        'Trabajo hasta las 8 PM y pensé que nunca iba a poder conseguir un buen barbero. VillaCon cambió todo eso. Llego a las 8:30 y me atienden igual que si fuera el primero del día.',
      t2Quote:
        'Llevo a mi hijo de 6 años ahí. Los barberos son increíblemente pacientes. Mi nene ya pide ir a VillaCon solo — dice que es SU barbería.',
      t3Quote:
        'El mejor fade del Bronx, sin discusión. Fui una vez y no volví a buscar otro barbero. ¿Para qué?',
      t4Quote:
        'Que estén abiertos hasta las 9 es un game changer. Nadie más en el área hace eso. Ya no tengo excusa para no verme bien.',
    },
    question: {
      heading: 'La Pregunta Que Tienes Que Hacerte:',
      q1: '¿Cuántas veces esta semana pensaste en que necesitas un corte?',
      q2: '¿Cuántas veces lo dejaste para después porque "no tuve tiempo"?',
      q3: '¿Cuántas veces llegaste tarde a la barbería y te tuviste que ir sin corte?',
      a1: 'Ese problema tiene solución.',
      a2: 'Y está en East Tremont Ave.',
    },
    experienceFlow: {
      heading1: 'Esto Es Lo Que Pasa',
      heading2: 'Cuando Entras a VillaCon:',
      s1: 'Te sientas en la silla.',
      s2: 'Tu barbero te escucha.',
      s3: 'Las tijeras y las clippers hacen su magia.',
      s4: 'Te limpian los bordes con precisión.',
      s5: 'Te das vuelta al espejo.',
      s6: 'Y lo ves.',
      p1: 'Ese fade limpio. Esas líneas perfectas. Esa versión tuya que siempre quisiste mostrarle al mundo.',
      p2: 'Y sales a la calle del Bronx sintiéndote exactamente como lo que eres:',
      king: 'El Rey de tu Barrio.',
    },
    faq: {
      heading1: 'Preguntas',
      heading2: 'Frecuentes',
      q1: '¿Hasta qué hora están abiertos?',
      a1: 'Hasta las 9 PM — los últimos en el área',
      q2: '¿Necesito cita?',
      a2: 'No — walk-ins bienvenidos. Pero puedes llamar al (347) 605-8521',
      q3: '¿Atienden niños?',
      a3: 'Sí — somos excelentes con niños, con paciencia y cuidado',
      q4: '¿Dónde están?',
      a4: '926A East Tremont Ave, Bronx, NY 10460',
      q5: '¿Qué servicios ofrecen?',
      a5: 'Fades, lineups, barba, cortes de niños, diseños personalizados',
      q6: '¿Tienen baño disponible?',
      a6: 'Sí — baño disponible para clientes',
      q7: '¿Cómo llego en metro?',
      a7: 'Cerca de las líneas del Bronx — llama para direcciones exactas',
    },
    finalCta: {
      banner: 'VEN HOY — ESTAMOS ESPERÁNDOTE',
      info: 'Información',
      l1: 'Teléfono',
      l2: 'Horario',
      v2: 'Abiertos hasta las 9 PM',
      l3: 'Niños',
      v3: 'Excelente para niños',
      l4: 'Walk-ins',
      v4: 'Bienvenidos',
      l5: 'Citas',
      v5: 'Llama al (347) 605-8521',
      l6: 'Transporte',
      v6: 'Fácil acceso en metro y bus',
      l7: 'Baño',
      v7: 'Disponible',
      closing:
        'No esperes más. Tu mejor versión está a una llamada de distancia.',
      b1: 'LLÁMANOS AHORA — (347) 605-8521',
      b2: 'VEN HOY — ABIERTOS HASTA LAS 9 PM',
      b3: 'HAZ TU CITA AHORA',
      b4: 'WALK-INS BIENVENIDOS',
      b5: 'RESERVA TU SPOT',
    },
    footer: {
      tagline: 'Where Legends Get Their Fade',
      hours: '(347) 605-8521 — Abiertos Hasta las 9 PM',
      rights: 'Todos los derechos reservados.',
    },
    booking: {
      subtitle:
        'Reserva tu cita con {name}. Te enviaremos un mensaje de texto con los detalles.',
      name: 'Nombre',
      namePh: 'Tu nombre',
      lastName: 'Apellido',
      lastNamePh: 'Tu apellido',
      date: 'Fecha',
      time: 'Hora',
      msg: 'Mensaje (opcional)',
      msgPh: 'Ej: Quiero un fade medio con diseño...',
      submit: 'ENVIAR MENSAJE',
      success: '¡Mensaje Enviado!',
      successSub:
        'Tu solicitud de cita fue enviada a {name}. Te responderá pronto.',
      close: 'CERRAR',
      smsTemplate:
        'Hola {barber}, soy {first} {last}. Quiero reservar una cita el {date} a las {time}.',
    },
  },
  en: {
    navbar: {
      openUntil: 'Open until 9 PM',
      callUs: 'CALL US',
    },
    hero: {
      subtitle: 'Everyone in the Bronx Knows',
      tagline1: 'Where Legends',
      tagline2: 'Get Their Fade',
      address: '926A East Tremont Ave, Bronx NY',
      openUntil: 'OPEN UNTIL 9 PM',
      cta: 'CALL NOW — (347) 605-8521',
      walkins: 'Walk-ins Welcome • Great with Kids',
    },
    painStory: {
      line1: "It's 7 PM.",
      line2: 'You just got off work.',
      line3: "You've been thinking about that haircut you need for days.",
      line4: 'But you know how this ends —',
      line5: 'You get to your usual barbershop and the sign says:',
      closed: '"CLOSED."',
      again: 'Again.',
      line6:
        'And you stand there on the street, with the same haircut from three weeks ago, thinking:',
      quote:
        '"Why is it so hard to find a good barbershop that understands my schedule?"',
      line7:
        "That's what everyone tells us when they come to VillaCon for the first time.",
      bullet1: 'Men who work during the day.',
      bullet2: 'Dads who only have free time at night.',
      bullet3: 'Young guys who go to school and get out late.',
      line8: 'All with the same thing in common:',
      line9:
        'Tired of neighborhood barbershops not respecting them or their time.',
    },
    problemList: {
      heading: 'You are not the problem.',
      sub1: 'The problem is that most barbershops in the Bronx close at 6 or 7 PM max.',
      sub2: "As if the men in the neighborhood didn't have real lives.",
      sub3: 'As if we all worked 9 to 5 and lived two blocks away.',
      sub4: 'And when you finally make it on time...',
      prob1: "The barber you like isn't there",
      prob2: 'The wait is an hour and a half',
      prob3: "The cut is rushed because they're hurrying to close",
      prob4: 'You pay the same for half the work',
      closing: "That's not a barbershop. That's disrespect.",
    },
    solution: {
      heading1: 'VillaCon BarberShop',
      heading2: 'exists for a reason:',
      subtitle:
        'So no man in the Bronx has to choose between working and looking fresh.',
      card1Title: 'In the heart of your neighborhood',
      card1Sub: 'Open in Google Maps →',
      card2Title: 'Our Hours',
      monThu: 'Mon – Thu',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
      closing: "Because we know your life doesn't end at 5.",
    },
    experience: {
      heading1: 'What awaits you when',
      heading2: 'you enter VillaCon?',
      line1:
        'From the moment you walk through the door, the experience is different.',
      noChaos: 'No chaos',
      noYelling: 'No yelling',
      noMess: 'No mess',
      prof: 'There is professionalism.',
      line2:
        'There is a barber who looks you in the eye, listens to you, and understands exactly what you want.',
      line3: 'And when you sit in that chair —',
      trust: 'You trust.',
      line4: "Because you know you're going to leave exactly as you asked.",
    },
    barbers: {
      heading1: 'Our',
      heading2: 'Team',
      subtitle: 'The professionals behind every perfect fade',
      barberLabel: 'Barber',
      bookHover: 'Book Appointment',
    },
    services: {
      heading1: 'Our',
      heading2: 'Services',
      s1Title: 'Perfect Fade',
      s1Desc: 'Low, mid or high — executed with surgical precision',
      s2Title: 'Lineup & Edges',
      s2Desc: 'Clean lines that define your style',
      s3Title: 'Beard Trim',
      s3Desc: 'Professional detail, perfect edges',
      s4Title: 'Kids Cuts',
      s4Desc: 'With patience, care and an expert hand',
      s5Title: 'Custom Designs',
      s5Desc: 'Your style, your identity, your cut',
      s6Title: 'Full Service',
      s6Desc: 'Cut + beard + full lineup',
    },
    additionalServices: {
      heading1: 'Additional',
      heading2: 'Services',
      subtitle: 'Complement your cut with our premium services',
      s1Title: 'Hair Treatment',
      s1Desc: 'Deep hydration and care for your hair',
      s2Title: 'Hot Towel',
      s2Desc: 'Total relaxation with a hot towel after the cut',
      s3Title: 'Eyebrows',
      s3Desc: 'Precise shaping and cleaning',
      s4Title: 'Hair Color',
      s4Desc: 'Professional color for a renewed look',
      s5Title: 'Black Mask',
      s5Desc: 'Deep facial cleansing with black mask',
      s6Title: 'Classic Shave',
      s6Desc: 'Traditional straight razor shave with hot lather',
    },
    banner: {
      heading1: 'Our',
      heading2: 'Styles',
      subtitle: 'Choose your style — we execute it with precision',
      overlay: '29+ Styles — Ask for Yours',
    },
    comparison: {
      heading1: 'Why VillaCon and Not Just Any',
      heading2: 'Other Tremont Barbershop:',
      col1: 'What You Find Elsewhere',
      col2: 'What You Find at VillaCon',
      mob1: 'Elsewhere',
      mob2: 'At VillaCon',
      c1Bad: 'Close at 6-7 PM',
      c1Good: 'Open until 9 PM every day',
      c2Bad: 'Different barber every visit',
      c2Good: 'Professionals who know your style',
      c3Bad: '2 hour waits without notice',
      c3Good: 'Organized and respectful service',
      c4Bad: 'Rushed cuts at the end of the day',
      c4Good: 'Same quality at 8 PM as at 9 AM',
      c5Bad: 'Not kid friendly',
      c5Good: 'Excellent for the whole family',
      c6Bad: 'Have to look for parking far away',
      c6Good: 'East Tremont Ave — in the heart of the hood',
      c7Bad: "Don't take late customers",
      c7Good: 'The only spot in Tremont open when others are closed',
    },
    lateHours: {
      subtitle: 'The Most Important Thing No One Else Gives You:',
      heading1: 'Open Until',
      heading2: '9 PM',
      line1: "Because your time is worth as much as anyone else's.",
      line2: "It doesn't matter if you got off work late.",
      line3: "It doesn't matter if you had to pick up the kids first.",
      line4: "It doesn't matter if your day didn't start until noon.",
      line5: 'At VillaCon',
      line6: 'there is always a spot for you.',
    },
    kids: {
      heading1: 'Bring Your',
      heading2: 'Son Too',
      q: 'Have kids?',
      line1: "We know what it's like trying to take a kid to the barbershop.",
      line2:
        "The wait. The discomfort. The little one's nervousness in the chair.",
      box: 'At VillaCon we are excellent with kids. Our barbers have patience, technique, and the special touch so your son leaves with the best cut — And with a smile.',
      quote:
        "Because when dad and son leave VillaCon together with the best fades in the neighborhood — That's priceless.",
    },
    testimonials: {
      heading1: 'What Our',
      heading2: 'Clients Say',
      t1Quote:
        "I work until 8 PM and thought I'd never be able to get a good barber. VillaCon changed all that. I arrive at 8:30 and they treat me just like I was the first of the day.",
      t2Quote:
        "I take my 6 year old son there. The barbers are incredibly patient. My boy now asks to go to VillaCon on his own — he says it's HIS barbershop.",
      t3Quote:
        'The best fade in the Bronx, hands down. Went once and never looked for another barber. Why would I?',
      t4Quote:
        'Being open until 9 is a game changer. No one else in the area does that. I have no excuse not to look good anymore.',
    },
    question: {
      heading: 'The Question You Have To Ask Yourself:',
      q1: 'How many times this week did you think about needing a cut?',
      q2: 'How many times did you put it off because "I didn\'t have time"?',
      q3: 'How many times did you get to the barbershop late and had to leave without a cut?',
      a1: 'That problem has a solution.',
      a2: "And it's on East Tremont Ave.",
    },
    experienceFlow: {
      heading1: 'This Is What Happens',
      heading2: 'When You Enter VillaCon:',
      s1: 'You sit in the chair.',
      s2: 'Your barber listens to you.',
      s3: 'The scissors and clippers work their magic.',
      s4: 'They clean your edges with precision.',
      s5: 'You turn to the mirror.',
      s6: 'And you see it.',
      p1: 'That clean fade. Those perfect lines. That version of yourself you always wanted to show the world.',
      p2: 'And you walk out onto the Bronx streets feeling exactly like what you are:',
      king: 'The King of your Hood.',
    },
    faq: {
      heading1: 'Frequently Asked',
      heading2: 'Questions',
      q1: 'Until what time are you open?',
      a1: 'Until 9 PM — the latest in the area',
      q2: 'Do I need an appointment?',
      a2: 'No — walk-ins welcome. But you can call (347) 605-8521',
      q3: 'Do you take kids?',
      a3: 'Yes — we are excellent with kids, with patience and care',
      q4: 'Where are you located?',
      a4: '926A East Tremont Ave, Bronx, NY 10460',
      q5: 'What services do you offer?',
      a5: 'Fades, lineups, beard, kids cuts, custom designs',
      q6: 'Do you have a restroom available?',
      a6: 'Yes — restroom available for customers',
      q7: 'How do I get there by subway?',
      a7: 'Close to the Bronx lines — call for exact directions',
    },
    finalCta: {
      banner: 'COME TODAY — WE ARE WAITING FOR YOU',
      info: 'Information',
      l1: 'Phone',
      l2: 'Hours',
      v2: 'Open until 9 PM',
      l3: 'Kids',
      v3: 'Excellent for kids',
      l4: 'Walk-ins',
      v4: 'Welcome',
      l5: 'Appointments',
      v5: 'Call (347) 605-8521',
      l6: 'Transit',
      v6: 'Easy access by subway and bus',
      l7: 'Restroom',
      v7: 'Available',
      closing: "Don't wait any longer. Your best version is a phone call away.",
      b1: 'CALL NOW — (347) 605-8521',
      b2: 'COME TODAY — OPEN UNTIL 9 PM',
      b3: 'BOOK YOUR APPOINTMENT NOW',
      b4: 'WALK-INS WELCOME',
      b5: 'RESERVE YOUR SPOT',
    },
    footer: {
      tagline: 'Where Legends Get Their Fade',
      hours: '(347) 605-8521 — Open Until 9 PM',
      rights: 'All rights reserved.',
    },
    booking: {
      subtitle:
        "Book your appointment with {name}. We'll send you a text message with the details.",
      name: 'First Name',
      namePh: 'Your first name',
      lastName: 'Last Name',
      lastNamePh: 'Your last name',
      date: 'Date',
      time: 'Time',
      msg: 'Message (optional)',
      msgPh: 'Ex: I want a mid fade with design...',
      submit: 'SEND MESSAGE',
      success: 'Message Sent!',
      successSub:
        'Your appointment request was sent to {name}. They will reply soon.',
      close: 'CLOSE',
      smsTemplate:
        "Hi {barber}, I'm {first} {last}. I want to book an appointment on {date} at {time}.",
    },
  },
}

export type Language = 'es' | 'en'
